import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars

const propTypes = {
  catalog: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
};

class EditCatalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        description: null,
      },
      catalog: {
        id: 0,
        name: '',
        description: '',
        items: [],
        setDisplayOrder: 'alpha',
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.catalog) {
      const { catalog } = nextProps;
      this.setState({ catalog });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { required, catalog } = this.state;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = catalog[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const { catalog } = this.state;
    if (e.target.type === 'checkbox') {
      catalog[e.target.name] = e.target.checked;
    } else {
      catalog[e.target.name] = e.target.value;
    }
    this.setState({
      catalog,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Catalog';
    nextState.dialogMessage = 'Do you really want to delete this catalog?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/catalogs/view/${this.state.catalog.id}`);
    }
  }
  navigateToSort() {
    if (this.state.edited === true) {
      const nextState = this.state;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/catalogs/sort/${this.state.catalog.id}`);
    }
  }
  handleDisplayOrderChange(event, index, value) {
    const { catalog } = this.state;
    catalog.setDisplayOrder = value;
    this.setState({
      catalog,
      edited: true,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
      assignedOnly: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/catalogs/view/${this.state.catalog.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Catalog changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this catalog?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
      assignedOnly: false,
    });
    const { catalog } = this.state;
    delete catalog.items;
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.catalog.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(catalog);
        break;
      default:
        this.props.onSave(catalog);
        break;
    }
  }
  handleCancel() {
    this.handleClose();
    browserHistory.push('/catalogs?page=1');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.saveChanges()}
          dialogTitle={this.state.dialogTitle}
          dialogMessage={this.state.dialogMessage}
          dialogActionTitle={this.state.dialogActionTitle}
        />
        <div className="float-right">
          <RaisedButton
            label="Cancel"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="View"
            primary
            onClick={this.navigateToView}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="Delete"
            primary
            onClick={this.handleDeleteOpen}
          />
          <RaisedButton
            label="Save"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleOpen}
          />
          <RaisedButton
            label="Sort Products"
            primary
            onClick={this.navigateToSort}
            disabled={this.state.catalog.setDisplayOrder === 'alpha'}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={this.state.catalog.id}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.catalog.name}
          name="name"
          onChange={this.handleChange}
          style={styles.inputStyle}
          errorText={this.state.required.name}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.state.catalog.description}
          name="description"
          onChange={this.handleChange}
          style={styles.inputStyle}
          errorText={this.state.required.description}
          errorStyle={{ color: cyan500 }}
          multiLine={true}
        />
        <SelectField
          value={this.state.catalog.setDisplayOrder}
          onChange={(event, index, value) => this.handleDisplayOrderChange(event, index, value)}
          floatingLabelText="Product Display Order"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          name="setDisplayOrder"
          floatingLabelStyle={styles.floatingLabelStyle}
        >
          <MenuItem value="alpha" primaryText="Alpha-A-Z" />
          <MenuItem value="user-defined" primaryText="User Defined" />
        </SelectField>
      </div>
    );
  }
}


EditCatalog.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditCatalog.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    catalog: state.catalogs.catalog,
  };
}

export default connect(mapStateToProps)(EditCatalog);



// WEBPACK FOOTER //
// ./src/components/catalogs/EditCatalog.js